import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { triggerJobSync } from '@/utils/syncJobs';
import { Loader2, RefreshCw, CheckCircle2 } from 'lucide-react';

export default function TriggerSync() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleSync = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      const data = await triggerJobSync();
      setResult(data);
      toast.success('Jobs erfolgreich synchronisiert!', {
        description: `${data.totalJobs} Jobs geladen`
      });
    } catch (error) {
      toast.error('Fehler beim Synchronisieren', {
        description: error instanceof Error ? error.message : 'Unbekannter Fehler'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary/20 p-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-4xl font-bold">Jobs Synchronisieren</h1>
          <p className="text-muted-foreground">
            Lädt aktuelle Jobs von Coveto und speichert sie in der Datenbank
          </p>
        </div>

        <Card className="p-8 space-y-6">
          <Button 
            onClick={handleSync} 
            disabled={loading}
            className="w-full"
            size="lg"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                Synchronisiere...
              </>
            ) : (
              <>
                <RefreshCw className="mr-2 h-5 w-5" />
                Jobs jetzt synchronisieren
              </>
            )}
          </Button>

          {result && (
            <div className="bg-secondary/50 rounded-lg p-6 space-y-4">
              <div className="flex items-center gap-2 text-green-600">
                <CheckCircle2 className="h-5 w-5" />
                <span className="font-semibold">Erfolgreich synchronisiert!</span>
              </div>
              
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="bg-background/50 rounded p-3">
                  <div className="text-muted-foreground mb-1">Gesamt</div>
                  <div className="text-2xl font-bold">{result.totalJobs}</div>
                </div>
                
                <div className="bg-background/50 rounded p-3">
                  <div className="text-muted-foreground mb-1">Neu</div>
                  <div className="text-2xl font-bold text-green-600">{result.newJobs}</div>
                </div>
                
                <div className="bg-background/50 rounded p-3">
                  <div className="text-muted-foreground mb-1">Aktualisiert</div>
                  <div className="text-2xl font-bold text-blue-600">{result.updatedJobs}</div>
                </div>
                
                <div className="bg-background/50 rounded p-3">
                  <div className="text-muted-foreground mb-1">Gelöscht</div>
                  <div className="text-2xl font-bold text-red-600">{result.deletedJobs}</div>
                </div>
              </div>
            </div>
          )}

          <div className="text-xs text-muted-foreground text-center space-y-1">
            <p>Diese Funktion lädt alle aktuellen Stellenangebote von Coveto</p>
            <p>und synchronisiert sie mit der Datenbank für optimale SEO-Performance.</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
